import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
// import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

// /// Dashboard
// import Home from "./components/Dashboard/Home";
// import DashboardDark from "./components/Dashboard/DashboardDark";
// import Performance from "./components/Dashboard/Performance";
// import Projects from "./components/Dashboard/Projects";
// import TaskSummary from "./components/Dashboard/TaskSummary";
// import Blog from "./components/Dashboard/Blog";
// import ManageClient from "./components/Dashboard/ManageClient";
// import Report from "./components/Dashboard/Report";
// import Finance from "./components/Dashboard/Finance";
// // import Employees from "./components/Dashboard/Employees";
// import Task from "./components/Dashboard/Task";
// import CoreHr from "./components/Dashboard/CoreHr";

// //Apps
// import Contacts from "./components/AppsMenu/Contacts";
// import User from "./components/AppsMenu/AppProfile/User";
// import UserRoles from "./components/AppsMenu/AppProfile/UserRoles";
// import AddRole from "./components/AppsMenu/AppProfile/AddRole";
// import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
// import AppProfile2 from "./components/AppsMenu/AppProfile/AppProfile2";
// import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
// import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
// import CustomerProfile from "./components/AppsMenu/AppProfile/CustomerProfile";
// import AppCustomer from "./components/AppsMenu/AppProfile/AppCustomer";
// import Compose from "./components/AppsMenu/Email/Compose/Compose";
// import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
// import Read from "./components/AppsMenu/Email/Read/Read";
// import Calendar from "./components/AppsMenu/Calendar/Calendar";

// /// Product List
// import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
// import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
// import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
// import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
// import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
// import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
// import Customers from "./components/AppsMenu/Shop/Customers/Customers";

// /// Charts
// import SparklineChart from "./components/charts/Sparkline";
// import ChartJs from "./components/charts/Chartjs";
// import RechartJs from "./components/charts/rechart";
// import ApexChart from "./components/charts/apexcharts";

// /// Bootstrap
// import UiAccordion from "./components/bootstrap/Accordion";
// import UiAlert from "./components/bootstrap/Alert";
// import UiBadge from "./components/bootstrap/Badge";
// import UiButton from "./components/bootstrap/Button";
// import UiModal from "./components/bootstrap/Modal";
// import UiButtonGroup from "./components/bootstrap/ButtonGroup";
// import UiListGroup from "./components/bootstrap/ListGroup";
// import UiCards from "./components/bootstrap/Cards";
// import UiCarousel from "./components/bootstrap/Carousel";
// import UiDropDown from "./components/bootstrap/DropDown";
// import UiPopOver from "./components/bootstrap/PopOver";
// import UiProgressBar from "./components/bootstrap/ProgressBar";
// import UiTab from "./components/bootstrap/Tab";
// import UiPagination from "./components/bootstrap/Pagination";
// import UiGrid from "./components/bootstrap/Grid";
// import UiTypography from "./components/bootstrap/Typography";

// /// Plugins
// import Select2 from "./components/PluginsMenu/Select2/Select2";
// import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
// import Toastr from "./components/PluginsMenu/Toastr/Toastr";
// import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
// import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
// // Widget
// import Widget from "./pages/Widget";
// /// Table
// import SortingTable from "./components/table/SortingTable/SortingTable";
// import FilteringTable from "./components/table/FilteringTable/FilteringTable";
// import BootstrapTable from "./components/table/BootstrapTable";
// /// Form
// import Element from "./components/Forms/Element/Element";
// import Wizard from "./components/Forms/Wizard/Wizard";
// import CkEditor from "./components/Forms/CkEditor/CkEditor";
// import Pickers from "./components/Forms/Pickers/Pickers";
// import FormValidation from "./components/Forms/FormValidation/FormValidation";
// /// Pages
// import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import VoucherSeries from "./pages/LIMSpages/VoucherSeries/VoucherSeries";
import AddVoucherSeries from "./pages/LIMSpages/VoucherSeries/AddVoucherSeries";
import UpdatePassword from "./pages/LIMSpages/UpdatePassword";
import Categories from "./pages/LIMSpages/Categories/Categories";
import ApplicationSetup from "./pages/LIMSpages/ApplicationSetup/ApplicationSetup";
import CompanyParameters from "./pages/LIMSpages/Companies/CompanyParameters";

import Courier from "./pages/LIMSpages/Courier/Courier";
import AddCourier from "./pages/LIMSpages/Courier/AddCourier";
import OperationStages from "./pages/LIMSpages/OperationStages/OperationStages";
import AddOperationStages from "./pages/LIMSpages/OperationStages/AddOperationStages";

import Customer from "./pages/LIMSpages/Customer/Customer";
import AddCustomer from "./pages/LIMSpages/Customer/AddCustomer";

import Branches from "./pages/LIMSpages/Branches/Branches";
import AddBranch from "./pages/LIMSpages/Branches/AddBranch";
import Employees from "./pages/LIMSpages/Employee/Employees";
import AddEmployee from "./pages/LIMSpages/Employee/AddEmployee";
import Vendors from "./pages/LIMSpages/Vendor/Vendors";
import AddVendor from "./pages/LIMSpages/Vendor/AddVendor";
import ProductGroup from "./pages/LIMSpages/ProductGroup/ProductGroup";
import AddProductGroup from "./pages/LIMSpages/ProductGroup/AddProductGroup";
import TestMethod from "./pages/LIMSpages/TestMethod/TestMethod";
import AddTestMethod from "./pages/LIMSpages/TestMethod/AddTestMethod";
import MaterialCategories from "./pages/LIMSpages/MaterialCategories/MaterialCategories";
import Departments from "./pages/LIMSpages/Departments/Departments";
import AddDepartment from "./pages/LIMSpages/Departments/AddDepartment";
import Parameters from "./pages/LIMSpages/Parameters/Parameters";
import AddParameters from "./pages/LIMSpages/Parameters/AddParameters";
import TestMaster from "./pages/LIMSpages/TestMaster/TestMaster";
import AddTestMaster from "./pages/LIMSpages/TestMaster/AddTestMaster";

import ReferenceStandardTestMapping from "./pages/LIMSpages/ReferenceStandardTestMapping/ReferenceStandardTestMapping";
import AddReferenceStandardTestMapping from "./pages/LIMSpages/ReferenceStandardTestMapping/AddReferenceStandardTestMapping";

import MaterialInward from "./pages/LIMSpages/MaterialInward/MaterialInward";
import AddMaterialInward from "./pages/LIMSpages/MaterialInward/AddMaterialInward";

import Machines from "./pages/LIMSpages/Machines/Machines";
import AddMachines from "./pages/LIMSpages/Machines/AddMachines";
import ReferenceStandard from "./pages/LIMSpages/ReferenceStandard/ReferenceStandard";
import AddReferenceStandard from "./pages/LIMSpages/ReferenceStandard/AddReferenceStandard";
import InwardApproval from "./pages/LIMSpages/InwardApproval/InwardApproval";
import AddInwardApproval from "./pages/LIMSpages/InwardApproval/AddInwardApproval";
import TC_TestAllocation from "./pages/LIMSpages/TC_TestAllocation/TC_TestAllocation";
import AddTC_TestAllocation from "./pages/LIMSpages/TC_TestAllocation/AddTC_TestAllocation";
import Testing from "./pages/LIMSpages/Testing/Testing";
import AddTesting from "./pages/LIMSpages/Testing/AddTesting";
import ReportPrinting from "./pages/LIMSpages/ReportPrinting/ReportPrinting";
import AddReportPrinting from "./pages/LIMSpages/ReportPrinting/AddReportPrinting";
import UploadScanCopy from "./pages/LIMSpages/UploadScanCopy/UploadScanCopy";
import AddUploadScanCopy from "./pages/LIMSpages/UploadScanCopy/AddUploadScanCopy";
import ControlCenter from "./pages/LIMSpages/ControlCenter/ControlCenter";
import MachineConfiguration from "./pages/LIMSpages/MachineConfiguration/MachineConfiguration";
import AddMachineConfiguration from "./pages/LIMSpages/MachineConfiguration/AddMachineConfiguration";
import MachiningOutward from "./pages/LIMSpages/MachiningOutward/MachiningOutward";
import AddMachiningOutward from "./pages/LIMSpages/MachiningOutward/AddMachiningOutward";
import AddMachiningInward from "./pages/LIMSpages/MachiningOutward/AddMachiningInward";
import ReportPrintingHtmlEditor from "./pages/LIMSpages/ReportPrinting/ReportPrintingHtmlEditor";
import ReportDispatch from "./pages/LIMSpages/ReportDispatch/ReportDispatch";
import AddReportDispatch from "./pages/LIMSpages/ReportDispatch/AddReportDispatch";
import MaterialDispatch from "./pages/LIMSpages/MaterialDispatch/MaterialDispatch";
import AddMaterialDispatch from "./pages/LIMSpages/MaterialDispatch/AddMaterialDispatch";
import CompanyList from "./pages/LIMSpages/Companies/CompanyList";
import EditUserProfile from "./pages/LIMSpages/Employee/EditUserProfile";
import UpgradeLicence from "./pages/LIMSpages/Companies/UpgradeLicence";
import MachinesCalibration from "./pages/LIMSpages/MachinesCalibration/MachinesCalibration";
import AddMachinesCalibration from "./pages/LIMSpages/MachinesCalibration/AddMachinesCalibration";
import Reports from "./pages/LIMSpages/Reports/Reports";
import InwardRegister from "./pages/LIMSpages/Reports/InwardRegister";
import ProcessStatus from "./pages/LIMSpages/Reports/ProcessStatus";
import DispatchReport from "./pages/LIMSpages/Reports/DispatchReport";
import DispatchMaterial from "./pages/LIMSpages/Reports/DispatchMaterial";
import PendingTesting from "./pages/LIMSpages/Reports/PendingTesting";
import Roles from "./pages/LIMSpages/Roles/Roles";
import AddRoles from "./pages/LIMSpages/Roles/AddRoles";
import AuthMiddleware from "./AuthMiddleware";
import Dashboard from "./pages/LIMSpages/Dashboard/Dashboard";
import Home from "./pages/LIMSpages/Dashboard/Home";
import MasterDataImport from "./pages/LIMSpages/MasterDataImport/MasterDataImport";
import PrintLabel from "./pages/LIMSpages/PrintLabel/PrintLabel";

import ChatBoxLIMS from "./pages/LIMSpages/Chat/ChatBoxLIMS";
import ChatHistory from "./pages/LIMSpages/Reports/ChatHistory";
import CommunicationLog from "./pages/LIMSpages/Reports/CommunicationLog";
import MachineCalibrationExpiry from "./pages/LIMSpages/Reports/MachineCalibrationExpiry";

import ReviseTestMethod from "./pages/LIMSpages/TestMethod/ReviseTestMethod";
import TestMasterRate from "./pages/LIMSpages/TestMasterRate/TestMasterRate";
import CustomerParameterRate from "./pages/LIMSpages/TestMasterRate/CustomerParameterRate";
import ReviseReferenceStandard from "./pages/LIMSpages/ReferenceStandard/ReviseReferenceStandard";
import PerformaInvoice from "./pages/LIMSpages/Invoice/PerformaInvoice";
import AddPerformaInvoice from "./pages/LIMSpages/Invoice/AddPerformaInvoice";
import Invoice from "./pages/LIMSpages/Invoice/Invoice";
import AddInvoice from "./pages/LIMSpages/Invoice/AddInvoice";
import Expenses from "./pages/LIMSpages/Expenses/Expenses";
import AddExpenses from "./pages/LIMSpages/Expenses/AddExpenses";
import AdvanceReceipt from "./pages/LIMSpages/AdvanceReceipt/AdvanceReceipt";
import AddAdvanceReceipt from "./pages/LIMSpages/AdvanceReceipt/AddAdvanceReceipt";
import PaymentReceipt from "./pages/LIMSpages/PaymentReceipt/PaymentReceipt";
import AddPaymentReceipt from "./pages/LIMSpages/PaymentReceipt/AddPaymentReceipt";
import OutstandingReport from "./pages/LIMSpages/ReportsAccount/OutstandingReport";
import InvoiceRegister from "./pages/LIMSpages/ReportsAccount/InvoiceRegister";
import PendingInvoice from "./pages/LIMSpages/ReportsAccount/PendingInvoice";
import PaymentReceiptRegister from "./pages/LIMSpages/ReportsAccount/PaymentReceiptRegister";

import EmailConfiguration from "./pages/LIMSpages/EmailConfiguration/EmailConfiguration";
import LedgerReport from "./pages/LIMSpages/ReportsAccount/LedgerReport";
import CreditNote from "./pages/LIMSpages/CreditNote/CreditNote";
import AddCreditNote from "./pages/LIMSpages/CreditNote/AddCreditNote";
import CustomerInward from "./pages/LIMSpages/CustomerLogin/Inward/CustomerInward";
import CustomerInvoice from "./pages/LIMSpages/CustomerLogin/Invoice/CustomerInvoice";
import CustomerLedgerReport from "./pages/LIMSpages/CustomerLogin/LedgerReport/CustomerLedgerReport";
import CustomerOutstandingReport from "./pages/LIMSpages/CustomerLogin/OutstandingReport/CustomerOutstandingReport";
import EmailTemplatesEdit from "./pages/LIMSpages/EmailTemplatesEdit/EmailTemplatesEdit";
import MachineResultCSVFileImport from "./pages/LIMSpages/MachineResultCSVFileImport/MachineResultCSVFileImport";
import WhatsAppConfiguration from "./pages/LIMSpages/WhatsAppConfiguration/WhatsAppConfiguration";
import MixDesignMaster from "./pages/LIMSpages/MixDesignMaster/MixDesignMaster";

import BroadcastMessage from "./pages/LIMSpages/BroadcastMessage/BroadcastMessage";
import CompanyLUTDocument from "./pages/LIMSpages/CompanyLUTDocument/CompanyLUTDocument";
import AddCompanyLUTDocument from "./pages/LIMSpages/CompanyLUTDocument/AddCompanyLUTDocument";
import BranchesReportingParameters from "./pages/LIMSpages/Branches/BranchesReportingParameters";
import NABLScope from "./pages/LIMSpages/NABLScope/NABLScope";
import AddNABLScope from "./pages/LIMSpages/NABLScope/AddNABLScope";
import UpdateScope from "./pages/LIMSpages/UpdateScope/UpdateScope";

import DocumentManagement from "./pages/LIMSpages/DocumentManagement/DocumentManagement";
import AddDocumentManagement from "./pages/LIMSpages/DocumentManagement/AddDocumentManagement";
import ReviseDocumentManagement from "./pages/LIMSpages/DocumentManagement/ReviseDocumentManagement";

import LogoValidity from "./pages/LIMSpages/LogoValidity/LogoValidity";
import AddLogoValidity from "./pages/LIMSpages/LogoValidity/AddLogoValidity";

import InventoryItems from "./pages/LIMSpages/InventoryItems/InventoryItems";
import AddInventoryItems from "./pages/LIMSpages/InventoryItems/AddInventoryItems";
import InventoryItemStock from "./pages/LIMSpages/InventoryItemStock/InventoryItemStock";
import AddInventoryItemStock from "./pages/LIMSpages/InventoryItemStock/AddInventoryItemStock";
import InventoryItemIssue from "./pages/LIMSpages/InventoryItemIssue/InventoryItemIssue";
import AddInventoryItemIssue from "./pages/LIMSpages/InventoryItemIssue/AddInventoryItemIssue";
import AddInventoryItemReturn from "./pages/LIMSpages/InventoryItemReturn/AddInventoryItemReturn";
import InventoryItemReturn from "./pages/LIMSpages/InventoryItemReturn/InventoryItemReturn";
import Films from "./pages/LIMSpages/Films/Films";
import AddFilms from "./pages/LIMSpages/Films/AddFilms";
import NDTCategory from "./pages/LIMSpages/NDTCategory/NDTCategory";
import Camera from "./pages/LIMSpages/Camera/Camera";
import AddCamera from "./pages/LIMSpages/Camera/AddCamera";
import Supplier from "./pages/LIMSpages/Supplier/Supplier";
import AddSupplier from "./pages/LIMSpages/Supplier/AddSupplier";
import InventoryGRN from "./pages/LIMSpages/InventoryGRN/InventoryGRN";
import AddInventoryGRN from "./pages/LIMSpages/InventoryGRN/AddInventoryGRN";
import InventoryItemWastage from "./pages/LIMSpages/InventoryItemWastage/InventoryItemWastage";
import AddItemInventoryWastage from "./pages/LIMSpages/InventoryItemWastage/AddInventoryItemWastage";

import AddSamplePreparationAndTesting from "./pages/LIMSpages/SamplePreparationAndTesting/AddSamplePreparationAndTesting";
import SamplePreparationAndTesting from "./pages/LIMSpages/SamplePreparationAndTesting/SamplePreparationAndTesting";
import InventoryItemDC from "./pages/LIMSpages/InventoryItemDC/InventoryItemDC";
import AddInventoryItemDC from "./pages/LIMSpages/InventoryItemDC/AddInventoryItemDC";

import ItemStockRegister from "./pages/LIMSpages/InventoryReport/ItemStockRegister";
import ItemIssueInOut from "./pages/LIMSpages/InventoryReport/ItemIssueInOut";

import AddMaterialInwardNDT from "./pages/LIMSpages/MaterialInwardNDT/AddMaterialInwardNDT";
import MaterialInwardNDT from "./pages/LIMSpages/MaterialInwardNDT/MaterialInwardNDT";
import AddTestingNDT from "./pages/LIMSpages/Testing/AddTestingNDT";

import MPTMaterial from "./pages/LIMSpages/MPTMaterial/MPTMaterial";
import AddMPTMaterial from "./pages/LIMSpages/MPTMaterial/AddMPTMaterial";

const allroutes = [
  // Dashboard
  { url: "", component: <Dashboard /> },
  { url: "dashboard", component: <Dashboard /> },
  { url: "home", component: <Home /> },
  // { url: "dashboard-dark", component: <DashboardDark /> },
  // { url: "core-hr", component: <CoreHr /> },
  // { url: "performance", component: <Performance /> },
  // { url: "project", component: <Projects /> },
  // { url: "task-summary", component: <TaskSummary /> },
  // { url: "blog", component: <Blog /> },
  // { url: "manage-client", component: <ManageClient /> },
  // // { url: "reports", component: <Report /> },
  // { url: "finance", component: <Finance /> },
  // // { url: "employee", component: <Employees /> },
  // { url: "task", component: <Task /> },
  // //Apps
  // { url: "contacts", component: <Contacts /> },
  // { url: "user", component: <User /> },
  // { url: "user-roles", component: <UserRoles /> },
  // { url: "add-role", component: <AddRole /> },
  // { url: "app-profile", component: <AppProfile /> },
  // { url: "app-profile-2", component: <AppProfile2 /> },
  // { url: "edit-profile", component: <EditProfile /> },
  // { url: "post-details", component: <PostDetails /> },
  // // { url: "customer", component: <AppCustomer /> },
  // { url: "customer-profile", component: <CustomerProfile /> },
  // // Apps
  // { url: "email-compose", component: <Compose /> },
  // { url: "email-inbox", component: <Inbox /> },
  // { url: "email-read", component: <Read /> },
  // { url: "app-calender", component: <Calendar /> },

  // // Shop
  // { url: "ecom-product-grid", component: <ProductGrid /> },
  // { url: "ecom-product-list", component: <ProductList /> },
  // { url: "ecom-product-detail", component: <ProductDetail /> },
  // { url: "ecom-product-order", component: <ProductOrder /> },
  // { url: "ecom-checkout", component: <Checkout /> },
  // { url: "ecom-invoice", component: <Invoice /> },
  // { url: "ecom-customers", component: <Customers /> },
  // // Chart
  // { url: "chart-sparkline", component: <SparklineChart /> },
  // { url: "chart-chartjs", component: <ChartJs /> },
  // { url: "chart-apexchart", component: <ApexChart /> },
  // { url: "chart-rechart", component: <RechartJs /> },
  // // Bootstrap
  // { url: "ui-accordion", component: <UiAccordion /> },
  // { url: "ui-alert", component: <UiAlert /> },
  // { url: "ui-badge", component: <UiBadge /> },
  // { url: "ui-button", component: <UiButton /> },
  // { url: "ui-modal", component: <UiModal /> },
  // { url: "ui-button-group", component: <UiButtonGroup /> },
  // { url: "ui-list-group", component: <UiListGroup /> },
  // { url: "ui-card", component: <UiCards /> },
  // { url: "ui-carousel", component: <UiCarousel /> },
  // { url: "ui-dropdown", component: <UiDropDown /> },
  // { url: "ui-popover", component: <UiPopOver /> },
  // { url: "ui-progressbar", component: <UiProgressBar /> },
  // { url: "ui-tab", component: <UiTab /> },
  // { url: "ui-pagination", component: <UiPagination /> },
  // { url: "ui-typography", component: <UiTypography /> },
  // { url: "ui-grid", component: <UiGrid /> },
  // // Plugin
  // { url: "uc-select2", component: <Select2 /> },
  // { url: "uc-sweetalert", component: <MainSweetAlert /> },
  // { url: "uc-toastr", component: <Toastr /> },
  // { url: "map-jqvmap", component: <JqvMap /> },
  // { url: "uc-lightgallery", component: <Lightgallery /> },
  // // Widget
  // { url: "widget-basic", component: <Widget /> },
  // // Form
  // { url: "form-element", component: <Element /> },
  // { url: "form-wizard", component: <Wizard /> },
  // { url: "form-ckeditor", component: <CkEditor /> },
  // { url: "form-pickers", component: <Pickers /> },
  // { url: "form-validation", component: <FormValidation /> },

  // // table
  // { url: "table-filtering", component: <FilteringTable /> },
  // { url: "table-sorting", component: <SortingTable /> },
  // { url: "table-bootstrap-basic", component: <BootstrapTable /> },
  // // { url: "*", component: <Home/> },

  /* -------------------- LIMS Pages -------------------- */

  { url: "customer-inward", component: <CustomerInward /> },
  { url: "customer-invoice", component: <CustomerInvoice /> },
  { url: "customer-ledger-report", component: <CustomerLedgerReport /> },
  {
    url: "customer-outstanding-report",
    component: <CustomerOutstandingReport />,
  },

  { url: "companies", component: <CompanyList /> },

  /* ----- Profile -----*/
  { url: "update-password", component: <UpdatePassword /> },
  { url: "application-setup", component: <ApplicationSetup /> },
  { url: "company-parameters", component: <CompanyParameters /> },
  { url: "branches", component: <Branches /> },
  { url: "add-branch", component: <AddBranch /> },
  { url: "edit-branch/:PrimaryIdParam", component: <AddBranch /> },
  { url: "upgrade-licence", component: <UpgradeLicence /> },
  {
    url: "edit-branch-parameters/:PrimaryIdParam",
    component: <BranchesReportingParameters />,
  },

  /* ----- System Setup ----- */
  //Categories
  { url: "categories", component: <Categories /> },

  // NDTCategory
  { url: "ndt-categories", component: <NDTCategory /> },

  // MPT Material
  { url: "mptmaterial", component: <MPTMaterial /> },
  { url: "add-mptmaterial", component: <AddMPTMaterial /> },
  { url: "edit-mptmaterial/:PrimaryIdParam", component: <AddMPTMaterial /> },

  // CAMERA
  { url: "camera", component: <Camera /> },
  { url: "add-camera", component: <AddCamera /> },
  { url: "edit-camera/:PrimaryIdParam", component: <AddCamera /> },

  //Voucher Series
  { url: "voucher-series", component: <VoucherSeries /> },
  { url: "add-voucher-series", component: <AddVoucherSeries /> },
  {
    url: "edit-voucher-series/:PrimaryIdParam",
    component: <AddVoucherSeries />,
  },

  //Employees
  { url: "employee", component: <Employees /> },
  { url: "add-employee", component: <AddEmployee /> },
  { url: "edit-employee/:PrimaryIdParam", component: <AddEmployee /> },
  { url: "edit-user-profile/:PrimaryIdParam", component: <EditUserProfile /> },

  //Company LUT Document
  { url: "company-lut-document", component: <CompanyLUTDocument /> },
  { url: "add-company-lut-document", component: <AddCompanyLUTDocument /> },
  {
    url: "edit-company-lut-document/:PrimaryIdParam",
    component: <AddCompanyLUTDocument />,
  },

  //Vendor
  { url: "vendor", component: <Vendors /> },
  { url: "add-vendor", component: <AddVendor /> },
  { url: "edit-vendor/:PrimaryIdParam", component: <AddVendor /> },

  //Courier
  { url: "courier", component: <Courier /> },
  { url: "add-courier", component: <AddCourier /> },
  {
    url: "edit-courier/:PrimaryIdParam",
    component: <AddCourier />,
  },

  //Films
  { url: "films", component: <Films /> },
  { url: "add-films", component: <AddFilms /> },
  { url: "edit-films/:PrimaryIdParam", component: <AddFilms /> },

  // Supplier
  { url: "supplier", component: <Supplier /> },
  { url: "add-supplier", component: <AddSupplier /> },
  { url: "edit-supplier/:PrimaryIdParam", component: <AddSupplier /> },

  //Email Configuration
  { url: "email-configuration", component: <EmailConfiguration /> },

  //WhatsApp Configuration
  { url: "whatsapp-configuration", component: <WhatsAppConfiguration /> },

  //Customer
  { url: "customer", component: <Customer /> },
  {
    url: "add-customer/:IsQuickAddCustomerParam",
    component: <AddCustomer />,
  },
  {
    url: "edit-customer/:IsQuickAddCustomerParam/:PrimaryIdParam",
    component: <AddCustomer />,
  },

  //Broadcast-Message

  { url: "broadcast-message", component: <BroadcastMessage /> },

  /* ----- Configuration ----- */
  // //Job - Work : OperationStages
  // { url: "operation-stages", component: <OperationStages /> },
  // { url: "add-operation-stages", component: <AddOperationStages /> },
  // {
  //   url: "edit-operation-stages/:PrimaryIdParam",
  //   component: <AddOperationStages />,
  // },

  //Material Configuration : Material Categories
  { url: "material-categories", component: <MaterialCategories /> },

  //Material Configuration : Departments
  { url: "departments", component: <Departments /> },
  { url: "add-department", component: <AddDepartment /> },
  {
    url: "edit-department/:PrimaryIdParam",
    component: <AddDepartment />,
  },

  //Material Configuration : Material Group
  { url: "product-groups", component: <ProductGroup /> },
  { url: "add-product-group", component: <AddProductGroup /> },
  {
    url: "edit-product-group/:PrimaryIdParam",
    component: <AddProductGroup />,
  },

  //Material Configuration : Test Method
  {
    url: "test-method",
    component: <TestMethod />,
  },
  {
    url: "add-test-method",
    component: <AddTestMethod />,
  },
  {
    url: "edit-test-method/:PrimaryIdParam",
    component: <AddTestMethod />,
  },

  {
    url: "revise-test-method/:PrimaryIdParam",
    component: <ReviseTestMethod />,
  },

  //Material Configuration : Parameters
  { url: "parameters", component: <Parameters /> },
  { url: "add-parameter", component: <AddParameters /> },
  { url: "edit-parameter/:PrimaryIdParam", component: <AddParameters /> },

  //Material Configuration : TestMaster
  { url: "test-master", component: <TestMaster /> },
  { url: "add-test-master", component: <AddTestMaster /> },
  { url: "edit-test-master/:PrimaryIdParam", component: <AddTestMaster /> },
  {
    url: "copy-test-master/:CopyTestMasterIdParam",
    component: <AddTestMaster />,
  },

  //Material Configuration : Rates
  { url: "test-master-rate", component: <TestMasterRate /> },
  { url: "customer-parameter-rate", component: <CustomerParameterRate /> },

  //Material Configuration : Reference Standard
  { url: "reference-standard", component: <ReferenceStandard /> },
  { url: "add-reference-standard", component: <AddReferenceStandard /> },
  {
    url: "edit-reference-standard/:PrimaryIdParam",
    component: <AddReferenceStandard />,
  },

  {
    url: "revise-reference-standard/:PrimaryIdParam",
    component: <ReviseReferenceStandard />,
  },
  //Material Configuration : Reference Standard - Test Mapping
  {
    url: "reference-standard-test-mapping",
    component: <ReferenceStandardTestMapping />,
  },
  {
    url: "add-reference-standard-test-mapping",
    component: <AddReferenceStandardTestMapping />,
  },
  {
    url: "edit-reference-standard-test-mapping/:PrimaryIdParam",
    component: <AddReferenceStandardTestMapping />,
  },

  {
    url: "copy-reference-standard-test-mapping/:CopyReferenceIdParam",
    component: <AddReferenceStandardTestMapping />,
  },

  //Machines - Machines
  { url: "machines", component: <Machines /> },
  { url: "add-machines", component: <AddMachines /> },
  { url: "edit-machines/:PrimaryIdParam", component: <AddMachines /> },

  //Machines - Calibration
  { url: "machines-calibration", component: <MachinesCalibration /> },
  { url: "add-machines-calibration", component: <AddMachinesCalibration /> },
  {
    url: "edit-machines-calibration/:PrimaryIdParam",
    component: <AddMachinesCalibration />,
  },

  //Machine Configuration
  { url: "machine-configuration-list", component: <MachineConfiguration /> },
  { url: "add-machine-configuration", component: <AddMachineConfiguration /> },
  {
    url: "edit-machine-configuration/:PrimaryIdParam",
    component: <AddMachineConfiguration />,
  },

  /* ----- Work Process ----- */
  // //Control Center
  // { url: "control-center", component: <ControlCenter /> },

  //Inward : Material Inward
  // { url: "material-inward", component: <MaterialInward /> },
  { url: "material-inward", component: <ControlCenter /> },
  { url: "add-material-inward", component: <AddMaterialInward /> },
  {
    url: "edit-material-inward/:PrimaryIdParam",
    component: <AddMaterialInward />,
  },
  {
    url: "copy-material-inward/:CopyInwardIdParam",
    component: <AddMaterialInward />,
  },
  {
    url: "edit-material-inward-header-detail/:editHeaderInwardIdParam",
    component: <AddMaterialInward />,
  },

  //Inward: TC/Test Allocation
  { url: "tc-test-allocation-list", component: <TC_TestAllocation /> },
  {
    url: "tc-test-allocation/:PrimaryIdParam",
    component: <AddTC_TestAllocation />,
  },

  {
    url: "view-material-inward/:ViewPrimaryIdParam",
    component: <AddTC_TestAllocation />,
  },

  //Inward : Inward Approval
  // { url: "inward-approval", component: <InwardApproval /> },
  {
    url: "add-inward-approval/:PrimaryIdParam",
    component: <AddInwardApproval />,
  },

  //Operation : Testing
  { url: "testing-list", component: <Testing /> },
  {
    url: "testing/:InwardMaterialIDParam",
    component: <AddTesting />,
  },

  {
    url: "testing-ndt/:InwardMaterialIDParam",
    component: <AddTestingNDT />,
  },
  {
    url: "testing-ndt/:InwardMaterialIDParam/:InwardMaterialTestDetailIDParam",
    component: <AddTestingNDT />,
  },

  {
    url: "testing/:InwardMaterialIDParam/:InwardMaterialTestDetailIDParam",
    component: <AddTesting />,
  },

  //Operation : Report Printing
  { url: "report-printing-list", component: <ReportPrinting /> },
  {
    url: "add-report-printing/:PrimaryIdParam",
    component: <AddReportPrinting />,
  },

  //Operation : Upload/Scan Copy
  { url: "upload-scan-copy-list", component: <UploadScanCopy /> },
  {
    url: "add-upload-scan-copy",
    component: <AddUploadScanCopy />,
  },
  {
    url: "edit-upload-scan-copy/:PrimaryIdParam",
    component: <AddUploadScanCopy />,
  },

  //Job Work : Machine Outward
  { url: "machining-outward-list", component: <MachiningOutward /> },
  {
    url: "add-machining-outward",
    component: <AddMachiningOutward />,
  },
  {
    url: "edit-machining-outward/:PrimaryIdParam",
    component: <AddMachiningOutward />,
  },
  {
    url: "add-machining-inward/:PrimaryIdParam",
    component: <AddMachiningInward />,
  },

  //Operation : Report Dispatch
  { url: "report-dispatch-list", component: <ReportDispatch /> },
  {
    url: "add-report-dispatch/:InwardIDParam/:InwardMaterialIDParam",
    component: <AddReportDispatch />,
  },
  {
    url: "edit-report-dispatch/:PrimaryIdParam",
    component: <AddReportDispatch />,
  },

  //Operation : Material Dispatch
  { url: "material-dispatch-list", component: <MaterialDispatch /> },
  {
    url: "add-material-dispatch/:InwardIDParam/:InwardMaterialIDParam",
    component: <AddMaterialDispatch />,
  },
  {
    url: "edit-material-dispatch/:PrimaryIdParam",
    component: <AddMaterialDispatch />,
  },

  { url: "reports", component: <Reports /> },
  { url: "inward-register", component: <InwardRegister /> },
  { url: "process-status", component: <ProcessStatus /> },
  { url: "dispatch-report", component: <DispatchReport /> },
  { url: "dispatch-material", component: <DispatchMaterial /> },
  { url: "pending-testing", component: <PendingTesting /> },
  { url: "chat-history", component: <ChatHistory /> },
  { url: "communication-log", component: <CommunicationLog /> },
  {
    url: "machine-calibration-expiry",
    component: <MachineCalibrationExpiry />,
  },

  { url: "master-data-import", component: <MasterDataImport /> },
  { url: "print-label", component: <PrintLabel /> },
  { url: "email-templates-edit", component: <EmailTemplatesEdit /> },
  {
    url: "machine-result-csv-file-import",
    component: <MachineResultCSVFileImport />,
  },

  /* ----- Account ----- */
  //Proforma Invoice
  { url: "proforma-invoice", component: <PerformaInvoice /> },
  { url: "add-proforma-invoice", component: <AddPerformaInvoice /> },
  {
    url: "edit-proforma-invoice/:PrimaryIdParam",
    component: <AddPerformaInvoice />,
  },

  //Invoice
  { url: "invoice", component: <Invoice /> },
  { url: "add-invoice", component: <AddInvoice /> },
  {
    url: "edit-invoice/:PrimaryIdParam",
    component: <AddInvoice />,
  },

  //Advance Receipt
  { url: "advance-receipt", component: <AdvanceReceipt /> },
  { url: "add-advance-receipt", component: <AddAdvanceReceipt /> },
  {
    url: "edit-advance-receipt/:PrimaryIdParam",
    component: <AddAdvanceReceipt />,
  },

  //Payment Receipt
  { url: "payment-receipt", component: <PaymentReceipt /> },
  { url: "add-payment-receipt", component: <AddPaymentReceipt /> },
  {
    url: "edit-payment-receipt/:PrimaryIdParam",
    component: <AddPaymentReceipt />,
  },

  //Credit Note
  { url: "credit-note", component: <CreditNote /> },
  { url: "add-credit-note", component: <AddCreditNote /> },
  {
    url: "edit-credit-note/:PrimaryIdParam",
    component: <AddCreditNote />,
  },

  //Expenses
  { url: "expenses", component: <Expenses /> },
  { url: "add-expenses", component: <AddExpenses /> },
  { url: "edit-expenses/:PrimaryIdParam", component: <AddExpenses /> },

  //Reports : Outstanding Report
  { url: "outstanding-report", component: <OutstandingReport /> },
  { url: "invoice-register", component: <InvoiceRegister /> },
  { url: "pending-invoice", component: <PendingInvoice /> },
  { url: "payment-receipt-register", component: <PaymentReceiptRegister /> },
  { url: "ledger-report", component: <LedgerReport /> },

  /* ----- Utility ----- */
  { url: "roles", component: <Roles /> },
  { url: "add-roles", component: <AddRoles /> },
  {
    url: "edit-roles/:PrimaryIdParam",
    component: <AddRoles />,
  },

  { url: "chat-box-lims", component: <ChatBoxLIMS /> },
  { url: "mix-design-master", component: <MixDesignMaster /> },
  { url: "update-scope", component: <UpdateScope /> },
  { url: "document-management", component: <DocumentManagement /> },
  { url: "add-document-management", component: <AddDocumentManagement /> },
  {
    url: "edit-document-management/:PrimaryIdParam",
    component: <AddDocumentManagement />,
  },
  {
    url: "revise-document-management/:PrimaryIdParam",
    component: <ReviseDocumentManagement />,
  },

  //NABL Scope
  { url: "nabl-scope", component: <NABLScope /> },
  { url: "add-nabl-scope", component: <AddNABLScope /> },
  {
    url: "edit-nabl-scope/:PrimaryIdParam",
    component: <AddNABLScope />,
  },

  //Logo Validity
  { url: "logo-validity", component: <LogoValidity /> },
  { url: "add-logo-validity", component: <AddLogoValidity /> },
  {
    url: "edit-logo-validity/:PrimaryIdParam",
    component: <AddLogoValidity />,
  },

  /* ----- Inventory -----*/
  { url: "items", component: <InventoryItems /> },
  { url: "add-items", component: <AddInventoryItems /> },
  {
    url: "edit-items/:PrimaryIdParam",
    component: <AddInventoryItems />,
  },
  { url: "inventory-item-stock", component: <InventoryItemStock /> },
  { url: "add-inventory-item-stock", component: <AddInventoryItemStock /> },
  {
    url: "edit-inventory-item-stock/:PrimaryIdParam",
    component: <AddInventoryItemStock />,
  },

  { url: "item-issue", component: <InventoryItemIssue /> },
  { url: "add-item-issue", component: <AddInventoryItemIssue /> },
  {
    url: "item-return",
    component: <InventoryItemReturn />,
  },
  {
    url: "add-item-return",
    component: <AddInventoryItemReturn />,
  },

  //InventoryGRN
  { url: "grn", component: <InventoryGRN /> },
  { url: "add-grn", component: <AddInventoryGRN /> },
  { url: "edit-grn/:PrimaryIdParam", component: <AddInventoryGRN /> },
  { url: "view-grn/:ViewPrimaryIdParam", component: <AddInventoryGRN /> },

  //Item Wastage
  { url: "item-wastage", component: <InventoryItemWastage /> },
  { url: "add-item-wastage", component: <AddItemInventoryWastage /> },
  {
    url: "edit-item-wastage/:PrimaryIdParam",
    component: <AddItemInventoryWastage />,
  },

  //Item DC
  { url: "item-dc", component: <InventoryItemDC /> },
  { url: "add-item-dc", component: <AddInventoryItemDC /> },
  {
    url: "edit-item-dc/:PrimaryIdParam",
    component: <AddInventoryItemDC />,
  },

  //Sample Preparation & Testing (Quick Report)
  {
    url: "sample-preparation-and-testing",
    component: <SamplePreparationAndTesting />,
  },
  {
    url: "add-sample-preparation-and-testing",
    component: <AddSamplePreparationAndTesting />,
  },
  {
    url: "edit-sample-preparation-and-testing/:PrimaryIdParam",
    component: <AddSamplePreparationAndTesting />,
  },
  {
    url: "view-sample-preparation-and-testing/:ViewPrimaryIdParam",
    component: <AddSamplePreparationAndTesting />,
  },

  //Inventory Reports
  { url: "item-stock-register", component: <ItemStockRegister /> },
  { url: "item-issue-in-out", component: <ItemIssueInOut /> },

  //NDT Material Inward
  { url: "ndt-material-inward", component: <MaterialInwardNDT /> },
  { url: "add-ndt-material-inward", component: <AddMaterialInwardNDT /> },
  {
    url: "edit-ndt-material-inward/:PrimaryIdParam",
    component: <AddMaterialInwardNDT />,
  },
  {
    url: "view-ndt-material-inward/:ViewPrimaryIdParam",
    component: <AddMaterialInwardNDT />,
  },
  {
    url: "copy-ndt-material-inward/:CopyInwardIdParam",
    component: <AddMaterialInwardNDT />,
  },
  {
    url: "edit-ndt-material-inward-header-detail/:editHeaderInwardIdParam",
    component: <AddMaterialInwardNDT />,
  },
];

const Markup = () => {
  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        {/* <Route path="/page-lock-screen" element={<LockScreen />} /> */}
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            // <Route
            //   key={i}
            //   exact
            //   path={`${data.url}`}
            //   element={data.component}
            // />
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={
                <AuthMiddleware
                  path={`${data.url}`}
                  component={data.component}
                  key={i}
                  exact
                >
                  {data.component}
                </AuthMiddleware>
              }
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
        <Route
          path="/print-report/:PrimaryIdParam/:IsDraftParam/:selectedTestIDsParam"
          element={<ReportPrintingHtmlEditor />}
        />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const sideMenu = useSelector((state) => state.sideMenu);
  return (
    <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />

      <div
        className="content-body"
        // style={{ minHeight: window.screen.height - 45 }}
      >
        {AuthUser?.displayExpiryNotification == true && (
          <marquee style={{ color: "red", marginBottom: "-8px" }}>
            {AuthUser?.expiryNotificationMessage}
          </marquee>
        )}

        {AuthUser?.displayExpiryIntimationNotification == true && (
          <marquee style={{ color: "red", marginBottom: "-8px" }}>
            {AuthUser?.expiryIntimationNotificationMessage}
          </marquee>
        )}
        <Outlet />
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default Markup;
